class ReviewsSlider {
  constructor(section) {
    this.section = section;
    this.slider = section.querySelector('[data-reviews-slider]');

    if (this.slider) {
      this.initSlider();
    }
  }

  initSlider() {
    this.swiperInstance = new Swiper(this.slider, {
      slidesPerView: 'auto',
      spaceBetween: 18,
      grabCursor: true,
      pagination: {
        el: this.section.querySelector('.section-reviews__pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: this.section.querySelector('.section-reviews__nav-next'),
        prevEl: this.section.querySelector('.section-reviews__nav-prev'),
      },
      breakpoints: {
        320: {
          spaceBetween: 12,
        },
        990: {
          spaceBetween: 18,
        },
      },
    });
  }

  destroy() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy();
    }
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReviewsSliders);
} else {
  initReviewsSliders();
}

function initReviewsSliders() {
  const sections = document.querySelectorAll('[data-section-type="reviews"]');
  sections.forEach((section) => {
    new ReviewsSlider(section);
  });
}

// Shopify Theme Editor support
if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="reviews"]');
    if (section) {
      new ReviewsSlider(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-section-type="reviews"]');
    if (section && section.reviewsSliderInstance) {
      section.reviewsSliderInstance.destroy();
    }
  });
}

window.ReviewsSlider = ReviewsSlider;
